export const CREATE_NHAN_VIEN_SUCCESS = "Thêm nhân viên thành công";
export const UPDATE_NHAN_VIEN_SUCCESS = "Sửa nhân viên thành công";
export const DELETE_NHAN_VIEN_SUCCESS = "Xóa nhân viên thành công";